import { render, staticRenderFns } from "./GroupVisitTable.vue?vue&type=template&id=1701906a&scoped=true"
import script from "./GroupVisitTable.vue?vue&type=script&lang=js"
export * from "./GroupVisitTable.vue?vue&type=script&lang=js"
import style0 from "./GroupVisitTable.vue?vue&type=style&index=0&id=1701906a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1701906a",
  null
  
)

export default component.exports